import * as React from "react"

interface FieldRowProps {
  label: string
  children: React.ReactNode
  "data-testid": string
}

export function FieldRow({ label, children, "data-testid": dataTestId }: FieldRowProps) {
  return (
    <div className="grid grid-cols-3 items-start gap-4" data-testid={dataTestId}>
      <label className="text-sm font-medium text-muted-foreground pt-2">
        {label}
      </label>
      <div className="col-span-2">{children}</div>
    </div>
  )
}
